import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { CommonService } from './common.service';
import { ErrorService } from './error.service';


@Injectable()
export class VersionService {

    private ewdUrl = CommonService.getEwdApiURL() + 'version';
    private transportApiUrl = CommonService.getTransportApiURL() + 'version';
    private emailApiUrl = CommonService.getEmailApiURL() + 'version';

    constructor(
      private http: Http,
      private errorService: ErrorService,
    ) { }

    getEWDVersion() {
        return this.http.get(this.ewdUrl)
          .map((response: Response) => {
            const result = response.text();
            return result;
          })
          .catch(this.errorService.handleError);
      }

    getTransportApiVersion() {
      return this.http.get(this.transportApiUrl)
        .map((response: Response) => {
          const result = response.text();
          return result;
        })
        .catch(this.errorService.handleError);
    }

    getEmailApiVersion() {
      return this.http.get(this.emailApiUrl)
        .map((response: Response) => {
          const result = response.text();
          return result;
        })
        .catch(this.errorService.handleError);
    }
}
